import React, { useMemo } from "react";
import { Route, Routes, BrowserRouter } from "react-router-dom";

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import LandingLayout from "../layout/landing/LandingLayout";

import Landing from "../pages/Landing";

export default function Router() {


    return (
        <>
            <BrowserRouter>
                <Routes>
                    <Route path="/" element={<LandingLayout />}>
                        <Route path="/" element={<Landing />} />
                        <Route path="/home" element={<Landing />} />
                    </Route>
                </Routes>
                <ToastContainer autoClose={2000} position="top-right" />
            </BrowserRouter>
        </>
    )
}